import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

const component = "QRLogin";

export const QRLoginQueryKeys = {
  qrCode: backendQueryKey<string>({ component, baseUrl: ENV.authBaseURL, endpoint: "/qr/generate" })
};
